var styles = {"colorInput":"styles_color-input__1c0IJ","empty":"styles_empty__jIlWq","colorPickerPopup":"styles_color-picker-popup__rfG56","content":"styles_content__KKTly"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
